<template>
  <component :is="readOnly ? 'div' : 'b-form-input'" :class="{'bg-gray-150':readOnly}"
             type="text" class="d-inline-block form-control form-control-sm h-100 text-wrap" v-model="valueFromProp">
    {{ _.trim(valueFromProp) }}
  </component>
</template>

<script>
  export default {
    name: 'gtc-text-box',
    props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      }
    },
    data: function () {
      return {
        valueFromProp: null
      }
    },
    created() {
      this.valueFromProp = this.value;
    },
    watch: {
      valueFromProp(newVal, oldVal) {
        let self = this;
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          self.$emit('input', newVal);
      },
      value(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          this.valueFromProp = newVal;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcTextBox.vue